import { Component, OnInit, ViewChild } from '@angular/core';
import { DashboardService } from '../service/dashboard.service';
import { Router } from '@angular/router';
// import { MatTableDataSource, MatPaginator } from '@angular/material';
import { MatTableDataSource, MatPaginator, MatDatepickerInputEvent, MAT_DATE_FORMATS, DateAdapter } from '@angular/material';
import { FormControl } from '@angular/forms';




import { MatDateFormats, MAT_NATIVE_DATE_FORMATS } from '@angular/material';
import Swal from 'sweetalert2';

export const GRI_DATE_FORMATS: MatDateFormats = {
  ...MAT_NATIVE_DATE_FORMATS,
  display: {
    ...MAT_NATIVE_DATE_FORMATS.display,
    dateInput: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    } as Intl.DateTimeFormatOptions,
  }
};

@Component({
  selector: 'app-stickerlistings',
  templateUrl: './stickerlistings.component.html',
  styleUrls: ['./stickerlistings.component.scss'],
  providers: [
    { provide: MAT_DATE_FORMATS, useValue: GRI_DATE_FORMATS },
  ]


})
export class StickerlistingsComponent implements OnInit {

  userdata;
  stickerall:any=[];
  searchdata;



  minDate: Date;
  maxDate: Date;

  startDate :any
  endDate  : any



  length: number;
  pageSize: number= 10;
  pageSizeOptions = [ 10, 20,50,100];



  @ViewChild(MatPaginator) paginator: MatPaginator;

  dataSource = new MatTableDataSource();
  displayedColumns = ['no','sticker_number' ,'agent_id', 'client_id', 'policy_number_nic','inception_date',
  'expiry_date','vehicle_number','date_modified']

  // <td>{{sticker.sticker_number}}</td>
  // <td>{{sticker.agent_id}}</td>
  // <td>{{sticker.client_id}}</td>s
  // <td>{{sticker.legacy_policy_number}}</td>
  // <td>{{sticker.policy_number_nic}}</td>
  // <td>{{sticker.inception_date}}</td>
  // <td>{{sticker.expiry_date}}</td>
  // <td>{{sticker.vehicle_number}}</td>
  // <td>{{sticker.managerEmail}}</td>
  // <td>{{sticker.created_at}}</td>
  // <td>{{sticker.date_modified}}</td>


  constructor(public service:DashboardService, public router:Router, private readonly adapter: DateAdapter<Date>) {


    const currentYear = new Date().getFullYear();
    this.minDate = new Date(currentYear - 2, 0, 1);
    // this.maxDate = new Date(currentYear + 1, 11, 31);
    this.maxDate = new Date(currentYear + 1, 0, 0);



   }


//initializing date
   date = new FormControl(new Date(new Date().setDate(new Date().getDate() - 30)));

   serializedDate = new FormControl((new Date()).toISOString().substring(0,10))




  ngOnInit() {

    this.userdata=JSON.parse(localStorage.getItem('userdata'))


    var today = new Date(); //get todays date
    this.endDate= today.toISOString().substring(0,10) //convert todays date to format eg.2019-08.02 and set it to end date

    today.setDate(today.getDate() - 30) // subtract 7 days from todays date
    this.startDate = today.toISOString().substring(0,10)

    Swal.showLoading();;
    this.service.getAllstickers({email:this.userdata.email, role :this.userdata.role ,minDate: this.startDate, maxDate : this.endDate}).subscribe(data=>{
      this.stickerall = data['responseData'];
      //this.searchdata = this.quotes;

      this.dataSource.data = data['responseData'];

      //console.log("datasource"+  this.dataSource )
      this.dataSource.paginator = this.paginator;

      Swal.close();
    })
  }

  // ngAfterViewInit() {
  //   this.dataSource.paginator = this.paginator;
  //  }



  find(){
    //email:this.ud.email,minDate:this.topperformstartdate,maxDate:this.topperformenddate,duration:days.toString(), role:this.ud.role}
    Swal.showLoading();;
    this.service.getAllstickers({email:this.userdata.email, role :this.userdata.role ,minDate: this.startDate, maxDate : this.endDate}).subscribe(data=>{
      this.stickerall = data['responseData'];
      //this.searchdata = this.quotes;

      this.dataSource.data = data['responseData'];

      //console.log("datasource"+  this.dataSource )
      this.dataSource.paginator = this.paginator;
     Swal.close();
  })




  }



  updateDate1(dateObject) {
    // convert object to string then trim it to yyyy-mm-dd
    const stringified = JSON.stringify(dateObject.value);
    this.startDate = stringified.substring(1, 11);
    // this.applicant.contact[0].dob = dob;

    console.log(this.startDate )
  }


  updateDate2(dateObject) {
    // convert object to string then trim it to yyyy-mm-dd
    const stringified = JSON.stringify(dateObject.value);
    this.endDate = stringified.substring(1, 11);
    // this.applicant.contact[0].dob = dob;

    console.log("end date " + this.endDate )
  }


  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  search (query: string){
    this.searchdata = (query) ?this.stickerall.filter( data => data.client_id.toLowerCase().includes(query.toLowerCase()) ||data.policy_number_nic.toLowerCase().includes(query.toLowerCase()) || data.vehicle_number.toLowerCase().includes(query.toLowerCase()) || data.expiry_date.toUpperCase().includes(query.toUpperCase())) : this.stickerall;
  }

  Transactions(){
    this.router.navigate(['/transactions'])
  }



    Policylists(){
      this.router.navigate(['/policylistings'])
    }





}
